import textServices from 'services/text-services'
import ErrorView from 'components/error-view'
import useMainClass, { usePopupContext } from 'hooks/use-main-cass'
import { useHistory } from 'react-router-dom'
import { AxiosError } from 'axios'

interface IProps {
  errorCode: AxiosError
  removeError: () => void
}

const PopUpError = ({ errorCode, removeError }: IProps) => {
  useMainClass('trivia__pop-up__error')
  const { closePopup } = usePopupContext()
  const history = useHistory()

  const onRetry = async () => {
    closePopup()
    removeError()
    history.push(textServices.findByText(`error/${errorCode}/button/link`, '/home'))
  }

  const buttonMenu = () => {
    closePopup()
    removeError()
    history.push(textServices.findByText(`error/${errorCode}/button/link`, '/home'))
  }

  if (errorCode) {
    return <ErrorView code={Number(errorCode) ?? 9999} buttonMenu={buttonMenu} onRetry={onRetry} />
  }

  return null
}

export default PopUpError
